import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
  settingsButton: {
    minWidth: "40px",
    padding: "0",
    marginLeft: "10px",
    minHeight: "40px",
    borderRadius: "40px",
  },
}));
